import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

import {
  Message
} from "element-ui";

import OrderDetails from '@/pages/MyOrder/OrderDetails'

import {
  httpGetserviceStatus
}
  from '@/api/common'

import Error from '@/pages/Error/Error'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: () =>
      import('@/pages/Home/Index.vue'),
    meta: {
      title: '微聘-招聘求职服务平台_简历优化_面试辅导_职业规划',
      keywords: '微聘，招聘，求职，简历优化，写简历，面试辅导，职业规划，内推',
      description: '微聘-招聘求职服务平台，资深HR/猎头为广大求职者提供简历优化、面试辅导、职业规划、内推职位等求职服务，专业-高效-安全，有效提升求职效率和成功率，专家指导求职无忧！'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/Login/Index'),
    meta: {
      title: '微聘-登录'
    }
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('@/pages/policy/PolicyDetail'),
      meta: {
        title: '微聘-隐私政策'
      }
    },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/pages/Login/Register'),
    meta: {
      title: '微聘-注册'
    }
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: () => import('@/pages/Login/Agreement'),
    meta: {
      title: '微聘-用户注册协议'
    }
  }, {
    path: '/expertagree',
    name: 'ExpertAgree',
    component: () => import('@/pages/Login/ExpertAgree'),
    meta: {
      title: '微聘-专家服务协议',
      requireLogin: true
    }
  }, {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: () => import('@/pages/Login/ForgotPassword'),
    meta: {
      title: '微聘-找回密码'
    }
  },
  {
    path: '/',
    name: 'expert',
    component: () => import('@/pages/Expert/Master'),
    children: [
      {
        path: '/user/order',
        name: 'UserOrder',
        component: () => import('@/pages/User/Order'),
        meta: {
          title: '微聘-订单管理',
          name:'订单管理'
        }
      },
      {
        path: '/user/orderdetail/:id',
        name: 'UserOrderDetail',
        component: () => import('@/pages/User/OrderDetail'),
        meta: {
          title: '微聘-订单详情',
          name:'订单管理'
        }
      },
      {
        path: '/expert/list',
        name: 'ExpertOrderExpert',
        component: () => import('@/pages/Expert/List'),
        meta: {
          title: '微聘-专家列表',
          name:'专家列表'
        }
      },
      {
        path: '/salaryReport',
        name: 'SalaryReport',
        component: () => import('@/pages/SalaryReport/index'),
        meta: {
          title: '微聘-薪酬报告',
          name:'薪酬报告'
        }
      },
      {
        path: '/expert/detail/:id',
        name: 'ExpertDetail',
        component: () => import('@/pages/Expert/Detail'),
        meta: {
          title: '微聘-专家详情',
          name:'专家列表'
        }
      },
      {
        path: '/expert/detail/:id',
        name: 'ExpertDetail',
        component: () => import('@/pages/Expert/Detail'),
        meta: {
          title: '微聘-专家详情'
        }
      },
      {
        path: '/user/order/pay/:id',
        name: 'UserOrderPay',
        component: () => import('@/pages/User/Pay'),
        meta: {
          title: '微聘-订单支付',
          name:'专家列表'
        }
      },
      {
        path: '/user/resume',
        name: 'UserEditResume',
        component: () => import('@/pages/User/EditResume'),
        meta: {
          title: '微聘-简历管理',
          name:'简历管理'
        },
      },
      {
        path: '/user/attachment',
        name: 'Attachment',
        component: () => import('@/pages/User/Attachment'),
        meta: {
          title: '微聘-附件管理',
          name: '附件管理'
        }
      }
    ]
  },
  {
    path: '/',
    name: 'FrameWork',
    component: () => import('@/pages/FrameWork/FrameWork'),
    children: [{
      path: 'order',
      name: 'MyOrder',
      component: () => import('@/pages/MyOrder/Index'),
      meta: {
          title: '微聘-我的订单',
          requireLogin: true
      }
    }, {
      path: 'orderdetails',
      name: 'OrderDetails',
      component: OrderDetails,
      props: true,
      meta: {
          title: '微聘-订单详情',
          requireLogin: true
      }
    }, {
      path: 'personinfo',
      name: 'PersonInfo',
      component: () => import('@/pages/PersonInfo/Index'),
      meta: {
          title: '微聘-个人资料',
          requireLogin: true
      }
    }, {
      path: 'personedit',
      name: 'PersonEdit',
      component: () => import('@/pages/PersonInfo/personEdit'),
      meta: {
          title: '微聘-个人资料编辑',
          requireLogin: true
      }
    }, {
      path: 'messagelist',
      name: 'MessageList',
      component: () => import('@/pages/Message/MessageList'),
      meta: {
        title: '微聘-个人资料编辑',
        requireLogin: true
      }
    }, {
      path: 'position',
      name: 'Position',
      component: () => import('@/pages/Position/Position'),
      meta: {
          title: '微聘-职位列表',
          requireLogin: true
      }
  }, {
      path: 'positiondetail/:id',
      name: 'PositionDetail',
      component: () => import('@/pages/Position/PositionDetail'),
      meta: {
          title: '微聘-职位详情',
          requireLogin: true
      }
  }, {
    path: 'positionresume/:id',
    name: 'PositionResume',
    component: () => import('@/pages/Position/PositionResume'),
    meta: {
      title: '微聘-投递简历详情',
      requireLogin: true
    }
  }, {
      path: 'positionadd',
      name: 'PositionAdd',
      component: () => import('@/pages/Position/PositionAdd'),
      meta: {
          title: '微聘-新增职位',
          requireLogin: true
      }
  }, {
      path: 'positionedit/:id',
      name: 'PositionEdit',
      component: () => import('@/pages/Position/PositionEdit'),
      meta: {
          title: '微聘-编辑职位',
          requireLogin: true
      }
  }]
  },
  {
    path: '*',
    component: Error
  }
  ]
})

// 路由拦截
// 不是所有版块都需要鉴权的
// 所以需要鉴权,我都会在路由meta添加添加一个字段requireLogin,设置为true的时候
// 就必须走鉴权,像登录页这些不要,是可以直接访问的!!!
router.beforeEach((to, from, next) => {
  store.dispatch("setroute", to.name);
  if (to.meta.keywords) {
    document.querySelector('meta[name=keywords]').setAttribute('content', to.meta.keywords);
  }
  if (to.meta.description) {
    document.querySelector('meta[name=description]').setAttribute('content', to.meta.description);
  }
  if (to.matched.some(res => res.meta.requireLogin)) {
    // 判断是否需要登录权限

    if (window.sessionStorage.getItem("loginUserBaseInfo")) {
      // 判断是否登录
      let lifeTime = JSON.parse(window.sessionStorage.getItem("seconds"));
      let nowTime = (new Date()).getTime(); // 当前时间的时间戳
      if (nowTime < lifeTime) {
        httpGetserviceStatus({
          id: JSON.parse(sessionStorage.getItem("loginUserBaseInfo")).id
        }).then(res => {
          if (res.success) {
            store.dispatch("userInfo", {
              id: JSON.parse(sessionStorage.getItem("loginUserBaseInfo")).id,
              phoneNum: JSON.parse(sessionStorage.getItem("loginUserBaseInfo")).phoneNum,
              authStatus: JSON.parse(sessionStorage.getItem("loginUserBaseInfo")).authStatus,
              serviceStatus: res.data
            });
            document.documentElement.scrollTop=0;
            next();
          } else {
            // this.$message({
            //     type: "error",
            //     message: res.message,
            //     duration: 1500
            // });
            console.log(res.message)
          }
        })

      } else {
        // alert("登录状态信息过期,请重新登录");
        Message({
          showClose: true,
          message: "登录状态信息过期,请重新登录",
          type: "error"
        });
        next({
          path: "/login"
        });
      }
    } else {
      // 没登录则跳转到登录界面
      next({
        path: "/login"
      });
    }
  } else {
    document.documentElement.scrollTop=0;
    next();
  }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js